/**
 * @import { Filters } from '@/features/world-map/types/filters'
 */

import { createContext, useContext } from 'react';

/**
 * @typedef {object} FiltersContext
 * @property {Filters} filters
 * @property {React.Dispatch<React.SetStateAction<Filters>>} setFilters
 */

/** @type {React.Context<FiltersContext>} */
// @ts-ignore
export const FiltersContext = createContext(null);

export const useFiltersContext = () => useContext(FiltersContext);
